<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(29)"
      :class="index == 29 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 29" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 29"
      />
      <div>总览</div>
    </div>
    <div
      class="button"
      @click="selectMenu(30)"
      :class="index == 30 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 30" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 30"
      />
      <div>视频监控</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;
  cursor: pointer;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
